import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Property1Default from "../components/Property1Default";
import SizeMediumStateDefaultSt1 from "../components/SizeMediumStateDefaultSt1";
import CustomizedTreatmentCard from "../components/CustomizedTreatmentCard";
import Footer from "../components/Footer";
import styles from "./Index1.module.css";

const Index1 = () => {
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeContainer1Click = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeContainer2Click = useCallback(() => {
    navigate("/services");
  }, [navigate]);

  const onAboutMeContainer3Click = useCallback(() => {
    navigate("/staff");
  }, [navigate]);

  return (
    <div className={styles.index1}>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.medicalIconiPhysicalTherapParent}>
            <img
              className={styles.medicalIconiPhysicalTherap}
              alt=""
              src="/medicaliconiphysicaltherapy1.svg"
            />
            <div className={styles.logo}>
              <img className={styles.logo1Icon} alt="" src="/logo-1.svg" />
              <b className={styles.personal}>
                <p className={styles.jJPhysical}>{`J &J Physical`}</p>
                <p className={styles.jJPhysical}>Therapy</p>
              </b>
            </div>
          </div>
          <div className={styles.taskbaar}>
            <Property1Default
              sectionTitle="Home"
              property1DefaultBorderRadius="15px"
              property1DefaultBackgroundColor="rgba(93, 37, 214, 0.63)"
              property1DefaultBoxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              property1DefaultPadding="10px"
              property1DefaultBoxSizing="border-box"
            />
            <div className={styles.aboutMe} onClick={onAboutMeContainer1Click}>
              <div className={styles.aboutMe1}>About</div>
            </div>
            <div className={styles.aboutMe} onClick={onAboutMeContainer2Click}>
              <div className={styles.aboutMe1}>Services</div>
            </div>
            <div className={styles.aboutMe} onClick={onAboutMeContainer3Click}>
              <div className={styles.aboutMe1}>Our Staff</div>
            </div>
          </div>
          <SizeMediumStateDefaultSt1
            linkText="Contact Us"
            showDownloadIcon={false}
            sizeMediumStateDefaultStCursor="pointer"
            sizeMediumStateDefaultStBorder="none"
            sizeMediumStateDefaultStBackgroundColor="#000"
            sizeMediumStateDefaultStHeight="56px"
            sizeMediumStateDefaultStJustifyContent="center"
            sizeMediumStateDefaultStPadding="var(--padding-base) var(--padding-xl)"
            sizeMediumStateDefaultStBoxSizing="border-box"
            sizeMediumStateDefaultStWidth="unset"
            sizeMediumStateDefaultStZIndex="unset"
            resumeDisplay="inline-block"
            onButtonContainerClick={onButtonClick}
          />
        </div>
      </div>
      <CustomizedTreatmentCard />
      <div className={styles.whatWeDoParent}>
        <b className={styles.whatWeDo}>{`What We Do... `}</b>
        <div className={styles.loremIpsumDolor}>
          Lorem ipsum dolor sit amet consectetur. Quis lorem consequat est
          varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor
          ultrices felis. Facilisis nunc hac sed lectus vehicula massa dui
          faucibus lacus. Euismod orci quis mauris purus accumsan justo nunc
          velit sagittis. Porttitor tempor commodo vitae tristique montes erat
          aliquam id est. Blandit tristique sagittis euismod et. Quis non
          integer amet tincidunt aenean.
        </div>
      </div>
      <div className={styles.whereWeAreWrapper}>
        <b className={styles.whereWeAre}>Where We Are</b>
      </div>
      <div className={styles.frameParent}>
        <div className={styles.wLaneSomewhereNy10800Parent}>
          <div className={styles.wLaneSomewhereContainer}>
            <p className={styles.jJPhysical}>2384 W. Lane</p>
            <p className={styles.jJPhysical}>Somewhere, NY 10800</p>
          </div>
          <div className={styles.hoursMonContainer}>
            <p className={styles.hours}>
              <b>Hours:</b>
            </p>
            <p className={styles.jJPhysical}>Mon. - Thur.  8:00 AM -5:00 PM</p>
            <p className={styles.jJPhysical}>Fri. 8:00 AM - 3:00 PM</p>
          </div>
        </div>
        <div className={styles.mapfake1Wrapper}>
          <img className={styles.mapfake1Icon} alt="" src="/mapfake-1@2x.png" />
        </div>
      </div>
      <div className={styles.indexInner}>
        <div className={styles.frameGroup}>
          <div className={styles.pexelsHelenaLopes10155681Wrapper}>
            <img
              className={styles.pexelsHelenaLopes10155681Icon}
              alt=""
              src="/pexelshelenalopes1015568-1@2x.png"
            />
          </div>
          <div className={styles.frameWrapper}>
            <div className={styles.signUpForOurMonthlyNewsleParent}>
              <b className={styles.signUpForContainer}>
                <p className={styles.signUpFor}>Sign Up for our</p>
                <p className={styles.jJPhysical}>Monthly Newsletter</p>
              </b>
              <div className={styles.loremConsequatEst}>
                lorem consequat est varius nulla imperdiet pulvinar. Faucibus
                nibh.
              </div>
              <div className={styles.rectangleParent}>
                <input
                  className={styles.frameChild}
                  placeholder="EMail"
                  type="text"
                />
                <button className={styles.subscribeWrapper}>
                  <div className={styles.subscribe}>Subscribe</div>
                </button>
              </div>
              <div className={styles.rectangleParent}>
                <button className={styles.bookAppointmentWrapper}>
                  <div className={styles.bookAppointment}>Book Appointment</div>
                </button>
                <button className={styles.freeConsultWrapper}>
                  <div className={styles.freeConsult}>{`Free Consult `}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frameDiv}>
        <div className={styles.frameParent1}>
          <div className={styles.jjPhysicalTherapyParent}>
            <div className={styles.jjPhysicalTherapyContainer}>
              <span className={styles.jjPhysical}>{`J&J Physical `}</span>
              <span>Therapy</span>
            </div>
            <div className={styles.fromPainTo}>
              From pain to progress, we're with you every step.
            </div>
          </div>
          <div className={styles.copyrightJjPhysicalTherapyWrapper}>
            <div
              className={styles.copyrightJjPhysical}
            >{` © Copyright j&j physical  therapy  inc.`}</div>
          </div>
        </div>
        <div className={styles.frameParent2}>
          <div className={styles.helpParent}>
            <div className={styles.help}>Help</div>
            <div className={styles.supportWebinarPlatformsContainer}>
              <p className={styles.jJPhysical}>Support</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Webinar Platforms</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Consult</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Video Chats</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Features</div>
            <div className={styles.ugentCareSpecialContainer}>
              <p className={styles.jJPhysical}>Ugent Care</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Special Programs</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>File Sharing</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Company</div>
            <div className={styles.aboutUsCareersContainer}>
              <p className={styles.jJPhysical}>About Us</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Careers</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Contact Us</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.contactUs1}>Contact Us</div>
            <div className={styles.junesjjtherapycom1800000}>
              <p className={styles.jJPhysical}>JuneS@jjtherapy.com</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>1-800-000-000</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>2384 W. Lane</p>
              <p className={styles.jJPhysical}>Somewhere, NY 10800</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Index1;
